<div class="row">
  <div class="col-lg-1 col-12 px-0">
    <app-uiform-side-menu
      [uiformId]="uiformId"
      targetId="info"
      [usecaseId]="usecaseId"
      [appId]="appId"
    >
    </app-uiform-side-menu>
  </div>

  <div class="col-lg-11 col-12 ps-lg-0 my-margin-left">
    <div class="row">
      <div class="col-12">
        <div class="breadcrumb-title border-0 mb-3">
          <div
            class="d-flex justify-content-start align-items-center gap-2 flex-wrap"
          >
            <mat-icon color="primary">info</mat-icon>
            <p class="text-break text-wrap mb-0">
              {{ form.data["title"] }} > {{'ALLREMAININGS.Info'| translate}}
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 col-auto mt-1">
        <div class="card shadow-sm border-0">
          <div class="card-header">
            <div class="d-flex justify-content-between align-items-center p-2">
              <div>
                <h6 class="card-title mb-1">{{ form.data["title"] }}</h6>
                <p class="mb-0 small">{{ form.data["description"] }}</p>
              </div>
              <span class="badge bg-secondary rounded-pill px-3 py-2">
                <i class="bi bi-fields me-1"></i>
                {{ form.data["fields"]?.length || 0 }} {{'ALLREMAININGS.Fields' | translate}}
              </span>
            </div>
          </div>

          <div class="card-body p-4">
            <div *ngIf="form.data['id'] > 0">
              <div class="table-container">
                <div class="table-responsive table-scrollable">
                  <table
                    class="table table-bordered table-hover table-sticky-header"
                  >
                    <thead>
                      <tr>
                         <th class="text-center">{{ 'INFORMATION.TABLE.SR_NO' | translate }}</th>
                         <th>{{ 'INFORMATION.TABLE.LABEL' | translate }}</th>
                         <th>{{ 'INFORMATION.TABLE.CODE' | translate }}</th>
                         <th>{{ 'INFORMATION.TABLE.TYPE' | translate }}</th>
                         <th>{{ 'INFORMATION.TABLE.REQUIRED' | translate }}</th>
                         <th>{{ 'INFORMATION.TABLE.UNIQUE' | translate }}</th>
                         <th>{{ 'INFORMATION.TABLE.VERSION' | translate }}</th>
                         <th>{{ 'INFORMATION.TABLE.EXTRA_DETAILS' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let field of form.data['fields']; let i = index"
                      >
                        <ng-container *ngIf="getAttributeById(field.id) as e">
                          <td class="text-center">{{ i + 1 }}</td>

                          <td>{{ e.label }}</td>

                          <td>
                            <span class="font-monospace">{{ e.code }}</span>
                          </td>

                          <td>
                            <span
                              class="badge rounded-pill"
                              [ngClass]="getTypeBadgeClass(e.type)"
                            >
                              {{ ('attributeslabel.' + e.type) | translate }}
                            </span>
                          </td>

                          <td>
                            <span
                              [class]="
                                e.required === 1 ? 'text-danger' : 'text-muted'
                              "
                            >
                              {{ e.required === 1 ? "Yes" : "No" }}
                            </span>
                          </td>

                          <td>
                            <span
                              [class]="
                                e.unique === 1 ? 'text-success ' : 'text-muted'
                              "
                            >
                              {{ e.unique === 1 ? "Yes" : "No" }}
                            </span>
                          </td>

                          <td>v{{ e.version }}</td>

                          <td>
                            <!-- Date range -->
                            <span
                              *ngIf="e.minDate || e.maxDate"
                              class="d-block text-muted"
                            >
                              <ng-container *ngIf="e.minDate"
                                >Min: {{ e.minDate }}</ng-container
                              >
                              <ng-container *ngIf="e.minDate && e.maxDate">
                                ·
                              </ng-container>
                              <ng-container *ngIf="e.maxDate"
                                >Max: {{ e.maxDate }}</ng-container
                              >
                            </span>

                            <!-- Time format -->
                            <span
                              *ngIf="e.timeFormat || e.itimeFormat"
                              class="d-block text-muted"
                            >
                              {{ e.timeFormat || e.itimeFormat }}h format
                            </span>

                            <!-- Default to current date -->
                            <span
                              *ngIf="e.defaultToCurrentDate"
                              class="badge bg-success-subtle text-success me-1"
                            >
                              Default: current date
                            </span>

                            <!-- Default to current time -->
                            <span
                              *ngIf="
                                e.defaultToCurrentTime ||
                                e.defaultToCurrentItime
                              "
                              class="badge bg-success-subtle text-success me-1"
                            >
                              Default: current time
                            </span>

                            <!-- Default to current datetime -->
                            <span
                              *ngIf="e.defaultToCurrentDateAndTime"
                              class="badge bg-success-subtle text-success me-1"
                            >
                              Default: current datetime
                            </span>

                            <!-- Datetime format -->
                            <span
                              *ngIf="e.dateTimeFormat"
                              class="d-block text-muted"
                            >
                              Format:
                              <span class="font-monospace">{{
                                e.dateTimeFormat
                              }}</span>
                            </span>

                            <!-- No change after initial -->
                            <span
                              *ngIf="e.allowChangeAfterInitial"
                              class="badge bg-warning-subtle text-warning me-1"
                            >
                              No change after initial
                            </span>

                            <!-- System field -->
                            <span
                              *ngIf="e.system"
                              class="badge bg-secondary-subtle text-secondary me-1"
                            >
                              System field
                            </span>

                            <!-- Dependent attribute -->
                            <span
                              *ngIf="e.depAttribute"
                              class="d-block text-muted"
                            >
                              Depends on: <span>{{ e.depAttribute }}</span>
                            </span>

                            <!-- Fallback -->
                            <span
                              *ngIf="
                                !e.minDate &&
                                !e.maxDate &&
                                !e.timeFormat &&
                                !e.itimeFormat &&
                                !e.defaultToCurrentDate &&
                                !e.defaultToCurrentTime &&
                                !e.defaultToCurrentItime &&
                                !e.defaultToCurrentDateAndTime &&
                                !e.dateTimeFormat &&
                                !e.allowChangeAfterInitial &&
                                !e.system &&
                                !e.depAttribute
                              "
                              class="text-muted"
                            >
                              —
                            </span>
                          </td>
                        </ng-container>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
